import script from "./ModeRegular.vue?vue&type=script&setup=true&lang=js"
export * from "./ModeRegular.vue?vue&type=script&setup=true&lang=js"

import "./ModeRegular.vue?vue&type=style&index=0&id=403287d3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-403287d3"]])

export default __exports__